/**
 * @fileoverview PUT handler for the "/:app_group_id/conversational/tool_definition/:id" endpoint
 */
import { exhaustiveCheck } from "@lib/exhaustiveCheck";
import fetch from "@lib/fetch";

import {
  createMutationFetcherFunctionWithShadowError,
  reactQueryMutationAdapter,
} from "../reactQueryFetcherAdapters";
import { conversationalToolDefinitionIdCacheKeys } from "./constants";
import type {
  ConversationalToolDefinitionIdResult,
  UpdateConversationalToolDefinitionIdErrors,
  UpdateConversationalToolDefinitionIdProps,
} from "./types";

const buildUpdateParams = (props: UpdateConversationalToolDefinitionIdProps): Record<string, unknown> => {
  switch (props.type) {
    case "workflow_attribute":
      return {
        type: props.type,
        description: props.description,
        allowed_values: props.allowedValues,
      };
    case "webhook":
      return {
        type: props.type,
        description: props.description,
        request_method: props.requestMethod,
        url: props.url,
        body: props.body,
        headers: props.headers,
        credential_name: props.credentialName,
        variables: props.variables,
        response_fields: props.responseFields,
      };
    case "custom_attribute":
      return {
        type: props.type,
        description: props.description,
        source: props.source,
        source_id: props.sourceId,
      };
    case "custom_event":
      return {
        type: props.type,
        description: props.description,
        properties: props.properties,
      };
    case "knowledge_source_search":
      return {
        type: props.type,
        description: props.description,
        excluded_fields: props.excludedFields,
      };
    default:
      exhaustiveCheck(props);
      return {};
  }
};

export const putConversationalToolDefinitionId = reactQueryMutationAdapter(
  conversationalToolDefinitionIdCacheKeys,
  createMutationFetcherFunctionWithShadowError<UpdateConversationalToolDefinitionIdErrors>()(
    (props: UpdateConversationalToolDefinitionIdProps): Promise<ConversationalToolDefinitionIdResult> => {
      return fetch(
        `/${props.appGroupId}/conversational/tool_definition/${props.definitionId}`,
        "PUT",
        buildUpdateParams(props),
        undefined,
        {
          propagateFetchRequestError: false,
        }
      );
    }
  )
);
